export default "__VITE_ASSET__UZODZ9rI__"